import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './Overlay_ConflictResolution.scss';
import { Panel_ConflictResolution } from '../Panel_ConflictResolution/Panel_ConflictResolution.js';
export class Overlay_ConflictResolution extends ComponentSync {
    __onShowConflictResolution = (dependencies) => {
        this.setState({ dependencies });
    };
    render() {
        if (!this.state.dependencies)
            return _jsx(_Fragment, {});
        return _jsx(Panel_ConflictResolution, { dependencies: this.state.dependencies });
    }
}
//# sourceMappingURL=Overlay_ConflictResolution.js.map